import { CardCompanyValues } from './types';

export const CARD_COMPANY_INITIAL_VALUES: CardCompanyValues = {
  cardCompanyId: null,
  apiKey: null,
  description: null,
  businessUnitId: null,
  isManualProcess: null,
};
